<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="downloadCsv(titleChart)" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="downloadId" :specificSiteId="specificSiteId" :zoomGraphValue="zoomGraphValue" :downloadShow="dataSource.categories && Object.keys(dataSource.categories).length > 0">
    <span slot="header" class="float-right enrol-tabs">
      <b-tabs>
        <b-tab v-for="(tabName, index) in tabList" :key="index" :title="tabName" @click="tabChange(tabName)" />
      </b-tabs>
    </span>
    <fusioncharts style="width: 100%;" :type="type" :width="width" :height="height" :dataFormat="dataFormat" :dataSource="dataSource" :events="fcEvents" dataEmptyMessage="No Data In" ref="overallChart" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0" slot="body" />
    <div slot="body" class="text-left min-height-0" v-if="dataSource.categories && Object.keys(dataSource.categories).length > 0">
      <span @click="zoomOutChart()" class="pl-10 pr-5 remove-zoom-icons">
        <img src="/static/img/icon-zoomout.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom Out" />
      </span>
      <span @click="zoomInChart()" class="remove-zoom-icons">
        <img src="/static/img/icon-zoomin.svg" class="download_graph cursor_pointer" aria-haspopup="true" aria-expanded="false" title="Zoom In" />
      </span>
    </div>
    <div v-else class="align-center p-60" slot="body">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>
<script>
import _cloneDeep from "lodash/cloneDeep";
import _get from "lodash/get";
import { downloadCSV, getContrast, primaryColorFnc, getSiteID } from "../../services/visualization/data-management";
import ChartContainer from "./chart-container.vue";
import moment from "moment";
import { ACTIVITIES, COUNTRIES, PARTICIPANTS, SITES } from "@/constants/config";
import * as ocm from "@/services/visualization/data-management-overall-collection";

const dataSources = {
  chart: {
    animation: "1",
    xaxisname: "Activities",
    yaxisname: "Number of Data Points",
    xAxisNameFontColor: "#959fa4",
    xAxisNameFont: "RobotoRegular",
    xAxisNameFontSize: "9px",
    labelFontSize: "10px",
    labelFont: "RobotoRegular",
    labelFontColor: "#a3a3a3",
    yAxisNameFontColor: "#a3a3a3",
    yAxisNameFont: "RobotoRegular",
    yAxisNameFontSize: "9px",
    yAxisValueFont: "RobotoRegular",
    yAxisValueFontSize: "10px",
    yAxisValueFontColor: "#a3a3a3",
    theme: "fusion",
    legendPosition: "right",
    legendItemFont: "RobotoRegular",
    legendItemFontSize: "10px",
    legendItemFontColor: "#666669",
    legendCaptionAlignment: "center",
    baseFontSize: "10",
    tooltipBorderAlpha: "0",
    toolTipBgAlpha: "0",
    showToolTipShadow: "0",
    divLineAlpha: "0",
    divLineDashed: "0",
    labelDisplay: "wrap",
    maxLabelHeight: "30",
    useEllipsesWhenOverflow: "1",
    maxColWidth: "42",
    plotHighlightEffect: "fadeout",
    plotSpacePercent: 30,
    reverseLegend: true,
    minimiseWrappingInLegend: true,
    showXAxisLine: true,
    showYAxisLine: true,
    xaxislinethickness: "1",
    yaxislinethickness: "1",
    xAxisLineColor: "#b0bac9",
    yAxisLineColor: "#b0bac9",
    chartBottomMargin: "0",
    xAxisNamePadding: "5",
    decimals: 3
  },
  categories: [],
  dataset: []
};
export default {
  components: {
    ChartContainer
  },
  props: {
    customType: { type: String, default: "scrollColumn2d" },
    zoomGraphValue: { type: String, default: "" },
    titleChart: { type: String, default: "" },
    subtitleChart: { type: String, default: "" },
    filterTriggered: { type: Boolean, default: false },
    sitesSelected: [Array, String],
    countrySelected: [Array, String],
    collectionMetricsRaw: { default: null },
    participantRaw: { default: null },
    specificSiteId: [Object, Array],
    siteListInParticipants: { type: Array, default: () => [] },
    listParticipants: [Array, null],
    dataLoaded: { type: Boolean, default: false }
  },
  data() {
    return {
      downloadId: "overall-data-collection-metrics",
      tabList: [ACTIVITIES, COUNTRIES, SITES, PARTICIPANTS],
      xAxisName: ACTIVITIES,
      type: this.customType,
      width: "100%",
      height: "250",
      dataFormat: "json",
      dataSource: dataSources,
      zoomGraphValueChild: "",
      curZoomLevel: 0,
      maxZoomLevel: 3,
      maxColumn: 0,
      todayDate: "",
      tDateShow: true,
      series: {},
      getSiteID,
      fcEvents: {
        dataPlotRollOver: evtObj => {
          const evtData = evtObj.data;

          let toolText;

          const el = document.getElementById("toolTextParticipant");

          if (el) {
            const displayValue = document.querySelector("#toolTextParticipant .data-label-text");
            const currID = _get(evtData, "categoryLabel", "");
            const isPID = this.siteListInParticipants.filter(item => item.participantName === currID).length > 0;
            toolText = `<span>${isPID ? "PID" : "TID"}: ${currID}</span><br/>${displayValue.outerHTML}`;
            el.innerHTML = toolText;
          }
        }
      }
    };
  },

  watch: {
    specificSiteId: function() {
      if (this.specificSiteId.length > 0) {
        this.tabList = [ACTIVITIES, COUNTRIES, PARTICIPANTS];
      }
    },
    filterTriggered: function() {
      this.series = ocm.GET_OVERALL_COLLECTION_SERIES(this.xAxisName === "Participants" ? this.participantRaw : this.collectionMetricsRaw, this.countrySelected, this.sitesSelected, this.xAxisName, this.listParticipants);
    },
    collectionMetricsRaw: function(newValue) {
      this.series = ocm.GET_OVERALL_COLLECTION_SERIES(this.xAxisName === "Participants" ? this.participantRaw : newValue, this.countrySelected, this.sitesSelected, this.xAxisName, this.listParticipants);
    },
    participantRaw: function(newValue) {
      this.series = ocm.GET_OVERALL_COLLECTION_SERIES(this.xAxisName === "Participants" ? newValue : this.collectionMetricsRaw, this.countrySelected, this.sitesSelected, this.xAxisName, this.listParticipants);
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250";
      }
    },
    series: function(newValue) {
      if (newValue && newValue.categories) {
        const { categories, dataset } = newValue;
        const datasources = _cloneDeep(dataSources);

        dataset[0] = {
          ...dataset[0],
          plottooltext: this.getPlotToolText("completed")
        };

        dataset[1] = {
          ...dataset[1],
          plottooltext: this.getPlotToolText("missing")
        };

        if (categories && categories[0].category.length > 0) {
          datasources.categories = [...categories];
          datasources.dataset = dataset;
          this.maxColumn = categories[0].category.length;
        }

        datasources.chart.numvisibleplot = 0;
        datasources.chart.xaxisname = this.xAxisName;
        datasources.chart.maxLabelHeight = this.xAxisName === "Participants" ? "20" : "30";

        this.dataSource = datasources;
      } else {
        const datasources = { categories: null };
        this.dataSource = datasources;
      }
    }
  },

  mounted() {
    if (this.series.categories) {
      const datasources = _cloneDeep(dataSources);
      const { categories, dataset } = this.series;

      dataset[0] = {
        ...dataset[0],
        plottooltext: this.getPlotToolText("completed")
      };

      dataset[1] = {
        ...dataset[1],
        plottooltext: this.getPlotToolText("missing")
      };

      if (categories && categories[0].category.length > 0) {
        datasources.categories = [...categories];
        datasources.dataset = dataset;
        this.maxColumn = categories[0].category.length;
      }

      datasources.chart.numvisibleplot = 0;
      datasources.chart.xaxisname = this.xAxisName;

      this.dataSource = datasources;
    }
  },
  methods: {
    tabChange(tabName) {
      this.xAxisName = tabName;
      this.series = ocm.GET_OVERALL_COLLECTION_SERIES(this.xAxisName === "Participants" ? this.participantRaw : this.collectionMetricsRaw, this.countrySelected, this.sitesSelected, this.xAxisName, this.listParticipants);
    },
    getNumVisPlotByZoom() {
      let numVisPlot = 0;
      switch (this.curZoomLevel) {
        case 0:
          numVisPlot = 0;
          break;
        case 1:
          numVisPlot = Math.round(0.75 * this.maxColumn);
          break;
        case 2:
          numVisPlot = Math.round(0.5 * this.maxColumn);
          break;
        case 3:
          numVisPlot = Math.round(0.2 * this.maxColumn);
          break;
        default:
          break;
      }
      return numVisPlot;
    },
    zoomInChart() {
      if (this.curZoomLevel < this.maxZoomLevel) {
        this.curZoomLevel = this.curZoomLevel + 1;
        const chartRef = this.$refs.overallChart.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    zoomOutChart() {
      if (this.curZoomLevel > 0) {
        this.curZoomLevel = this.curZoomLevel - 1;
        const chartRef = this.$refs.overallChart.chartObj;
        const data = chartRef.getJSONData();
        const numVisPlot = this.getNumVisPlotByZoom();
        data.chart.numvisibleplot = numVisPlot;
        chartRef.setJSONData(data);
      }
    },
    getPlotToolText(type = "completed") {
      const hexColor = type === "completed" ? primaryColorFnc() : "#cab2d6";
      const defaultToolText = `<div class="overall-collection-metric-tooltip ${type}" style='color:${getContrast(hexColor)}'>
                  <span>$label</span><br/>
                  <span class="data-label-text">$value $seriesName Data Points</span>
              </div>`;
      const participantToolText = `<div id="toolTextParticipant" class="overall-collection-metric-tooltip ${type}" style='color:${getContrast(hexColor)}'>
                <span>PID: $label</span><br/>
                <span class="data-label-text">$value $seriesName Data Points</span>
            </div>`;
      return this.xAxisName === "Participants" ? participantToolText : defaultToolText;
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    downloadCsv(titleChart) {
      this.todayDate = moment()
        .format("DD MMM YYYY hh:mm:ss")
        .toUpperCase();
      this.tDateShow = false;

      setTimeout(() => {
        const header = ["Activities", "Completed", "Missing"];
        const newArr = [];
        header[0] = this.xAxisName;
        this.tDateShow = true;
        this.dataSource.categories[0].category.map(row => {
          newArr.push([row.label]);
        });

        this.dataSource.dataset[0].data.map((row, i) => {
          newArr[i].splice(2, 0, row.value);
        });

        this.dataSource.dataset[1].data.map((row, i) => {
          newArr[i].splice(2, 0, row.value);
        });

        downloadCSV(titleChart, header, newArr, this.specificSiteId);
      }, 1);
    }
  }
};
</script>
